import { supabase } from "../../utils/supabaseClient"
import Image from "next/image"
import { Check, ArrowLeft } from "react-bootstrap-icons"
import { cloudfront, features } from "../../config"
import Link from "next/link"
import Layout from '../../components/Layouts/homeLayout'
import { useAuth, AuthProvider } from "../../contexts/Auth"
import AlertTemplate from '../../components/Notification'
import { transitions, positions, Provider as AlertProvider } from 'react-alert'
import Meta from "../../components/Meta"
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Filler,
  Tooltip,
  Legend,
} from 'chart.js';
import { Line } from 'react-chartjs-2';

ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
  Filler
);

export async function getStaticPaths() {
    const {data, error} = await supabase
      .from('main_dynamic_how_to')
      .select('slug, status')
      .match({status:"active"})
    
    error && console.log(error)
      
    const paths = data.map((obj) => ({ params: { slug: obj.slug }}))

    return {
      paths,
      fallback: 'blocking'
    }
  }
  
  export async function getStaticProps(context) {
      //the article
      const {data, error} = await supabase
        .from('main_dynamic_how_to')
        .select('*')
        .match({slug: context.params.slug})

      error && console.log(error)

      const article = data[0]


    return {
        props: {
            article
        }
    }
  }



export default function ArticleSlug({article}) {
    const promptArr = [
        {intro: `What does a ${article.id < 34 ? "virtual" : ""} ${article.vertical} coach do?`},
        {how :`How to become a ${article.id < 34 ? "virtual" : ""} ${article.vertical} coach?`},
        {certs: `Certifications to pursue ${article.id < 34 ? "virtual" : ""} ${article.vertical} coaching`},
        {fbGroups :`What facebook groups should a ${article.id < 34 ? "virtual" : ""} ${article.vertical} coaching follow?`},
        {grow: `How to grow as a ${article.id < 34 ? "virtual" : ""} ${article.vertical} coach?`},
        {targets: `Who should a ${article.vertical} coach target for their services?`},
        {things: `Things to remember as a ${article.id < 34 ? "virtual" : ""} ${article.vertical} coach`}
    ]


    return (
        <div className="bg-slate-200/50 h-full pt-5">
          <Meta 
              title={`How to Become an Online ${article.vertical.charAt(0).toUpperCase() + article.vertical.slice(1)} Coach`}
              description={article.intro.slice(0, 155)}
          />
          <div className=" text-left overflow-hidden bg-slate-200/80 ">
          <div className="mt-20 text-slate-400 font-bold  mx-auto w-3/4  rounded-lg hover:text-slate-800">
            <Link href={"/guides/coach"}>
              <a className="flex items-center space-x-2">
                <ArrowLeft size={20}/>
                <p className="text-slate-400 hover:text-slate-700 text-base font-semibold">Return to Guide</p>
              </a>
              </Link>
              
            </div>

            <h1 className="font-extrabold  text-4xl w-3/4 mx-auto pt-4 pb-20 text-slate-800 font-serif ">How to Become an Online {article.vertical.charAt(0).toUpperCase() + article.vertical.slice(1)} Coach</h1>
            {article.video &&
            <div>
                <video alt="How to Become an online dating coach" controls className="w-[90%] sm:w-1/2 mx-auto rounded-lg aspect-video mb-20">
                    <source src={`${cloudfront}/media/stock_videos/${article.video}`} type="video/mp4"/>
                  </video>
            </div>
          }
          </div>

          
          <div className="absolute  h-full w-full overflow-hidden z-0" aria-hidden="true">
          <div className="relative h-full overflow-hidden">
            <svg
              className="absolute right-full transform translate-y-1/3 translate-x-1/4 md:translate-y-1/2 sm:translate-x-1/2 lg:translate-x-full"
              width={404}
              height={784}
              fill="none"
              viewBox="0 0 404 784"
            >
              <defs>
                <pattern
                  id="e229dbec-10e9-49ee-8ec3-0286ca089edf"
                  x={0}
                  y={0}
                  width={20}
                  height={20}
                  patternUnits="userSpaceOnUse"
                >
                  <rect x={0} y={0} width={4} height={4} className="text-gray-200" fill="currentColor" />
                </pattern>
              </defs>
              <rect width={404} height={784} fill="url(#e229dbec-10e9-49ee-8ec3-0286ca089edf)" />
            </svg>
            <svg
              className="absolute left-full transform -translate-y-3/4 -translate-x-1/4 sm:-translate-x-1/2 md:-translate-y-1/2 lg:-translate-x-3/4"
              width={404}
              height={784}
              fill="none"
              viewBox="0 0 404 784"
            >
              <defs>
                <pattern
                  id="d2a68204-c383-44b1-b99f-42ccff4e5365"
                  x={0}
                  y={0}
                  width={20}
                  height={20}
                  patternUnits="userSpaceOnUse"
                >
                  <rect x={0} y={0} width={4} height={4} className="text-gray-200" fill="currentColor" />
                </pattern>
              </defs>
              <rect width={404} height={784} fill="url(#d2a68204-c383-44b1-b99f-42ccff4e5365)" />
            </svg>
            
            
          </div>
        </div>
          <div className="lg:mx-20 mx-4 pt-10 text-left pb-48 z-20 relative">
            <div className="flex md:flex-row flex-col justify-between">
            <div className="space-y-12 w-full md:w-2/3">
            {article.content ?
              
                <div className="text-slate-800 text-lg mx-auto sm:w-3/4" style={{whiteSpace: "pre-wrap"}} dangerouslySetInnerHTML={{__html: article.content}}/>
     
            :
            
            promptArr.map(obj => Object.keys(obj)[0]).map((key, index) => (
              article[key] && 
                  <div key={`topic-${index}`} className="mx-auto sm:w-3/4">
                      <h3 className="text-slate-800 font-bold text-2xl">{promptArr[index][key]}</h3>
                      <p className="text-xl text-slate-700 -mt-12" style={{whiteSpace:"pre-line"}}>{article[key]}</p>
                  </div>
            ))}

              {article.directory_link && (
                <div className="mx-auto sm:w-3/4 text-slate-700">
                  <h2 className="mb-4 font-bold text-2xl text-slate-800">Conclusion</h2>
                  <p>We hope this helps kickstart your journey towards becoming a {article.vertical} coach.  Check out our  <Link href={`/coaches/${article.directory_link}`}><a className="underline font-semibold"> directory</a></Link>
                  {` `}if you are looking for more inspiration or just need some examples of successful {article.vertical} coaches.
                  </p>
                </div>
              )}

            </div>
            <div className="w-full md:w-1/3">
              {article.trend_data && 
                <>
                <h2 className="text-slate-800 font-bold text-2xl mt-[38px] mb-5">Analytics</h2>
              <div className="bg-slate-200 p-2 rounded-md">
    
              <Line
                        datasetIdKey='id'
                        data={{
                            labels: article.trend_data?.map(obj => obj.formattedTime),
                            datasets: [
                                {
                                    id: 1,
                                    label: `Interest for ${article.vertical.charAt(0).toUpperCase() + article.vertical.slice(1)} Coach over time`,
                                    data: article.trend_data?.map(obj => obj.value[0]),
                                    borderColor: 'rgb(192, 38, 211)',
                                    backgroundColor: 'rgba(243, 167, 252, 0.5)',
                                    fill: {
                                        target: 'origin',
                                        below: 'rgb(192, 38, 211)'    // And blue below the origin
                                      }
                                },
                            ],
                        }}
                        />
              <p className="text-sm italic mt-3 text-gray-500">*Based on search engine data</p>
              </div>
                
                
                
                
                
                </>
              
              }
             
              {article.salary_data && 
                    <div className="bg-slate-200 p-2 mt-10 rounded-md">
                    <p className="text-sm text-gray-500 text-center mb-1">Salary Data USD</p>
                    <table className="table-auto w-full" style={{width:"100%", color: "#6B7280"}}>
                        <thead className="border-b border-gray-300">
                          <tr >
                            <th>Publisher</th>
                            <th>Min</th>
                            <th>Median</th>
                            <th>Max</th>
                            <th>Period</th>
                          </tr>
                        </thead>
                        <tbody>
                          {article.salary_data.map((obj,index) => (
                              <tr key={`sal-${index}`}>
                                <td>{obj.publisher_name}</td>
                                <td>{Math.round(obj.min_salary)}</td>
                                <td>{Math.round(obj.median_salary)}</td>
                                <td>{Math.round(obj.max_salary)}</td>
                                <td>{obj.salary_period.toLowerCase()}</td>
                            </tr>


                          ))}
                         
                        </tbody>
                      </table>
                </div>
              
              }
        

             
            </div>

            </div>

              {/* CTA */}
            <div className="bg-white rounded-lg shadow-lg mt-32 border flex flex-col sm:flex-row justify-between">
              <div className="p-10 shadow z-10 w-full sm:w-[60%] text-center">
              <h2 className="text-slate-800 font-bold text-2xl">Get started today with Plaza</h2>
                <p className="text-slate-800 text-base">Everything you need for your virtual coaching business</p>
                <div className="flex space-x-3 mt-4 mx-auto w-72 ">
                  <Link href="/">
                  <a
                  className="inline-flex items-center px-4 py-2 border border-transparent text-base font-medium rounded-md hover:bg-fuchsia-800 text-white shadow-lg shadow-fuchsia-500/50 bg-fuchsia-700"
                  >Get Started</a>
                </Link>
                <Link href="/">
                  <a
                  className="inline-flex items-center px-4 py-2 border border-transparent text-base font-medium rounded-md hover:bg-slate-700 text-white shadow-lg shadow-slate-500/50 bg-slate-600"
                  >Book a Demo</a>
                </Link>

                </div>
                <div className="my-2 mx-auto text-center">
    
                <Image
                     objectFit={'contain'}
                     src={`${cloudfront}/static/branding_group.png`}
                     width={500}
                     height={300}
                     alt="Plaza for video consultations"
                 
                 />
                  </div>
  
              </div>
              <div className="space-y-5 p-10 bg-slate-100 w-full sm:w-[40%]">
                {features.map(string => (
                  <div key={string} className="flex justify-start items-center space-x-4">
                    <div className=""><Check className="bg-green-400 text-white rounded-full"/></div>
                    <p className="text-slate-700 font-semibold text-base"  key={string}>{string}</p>
                  </div>
                ))}
              </div>
       
            </div>
          </div>


          <div className="w-full flex justify-center">
            <p className="text-slate-500 text-base">© 2023 Ordinary Media, LLC. All Rights Reserved.</p>

          </div>
          <style jsx global>{`
              p > a {
                text-decoration:underline;
              }
              p > a:hover {
                color: rgb(23, 40, 70);
              }
              p {
                font-size: 1.25rem; /* 20px */
                line-height: 1.75rem; /* 28px */
                color:rgb(71 85 105);
              }
              h1 {
                font-size: 2em;
              }

              h2 {
                font-size: 1.5em;
              }
              h3 {
                font-size: 1.17em;
                margin-top:40px;
                margin-bottom:5px;
              }`}
          </style>
        </div>
    );
}


const alertOptions = {
  // you can also just use 'bottom right'
  position: positions.BOTTOM_RIGHT,
  timeout: 3000,
  offset: '10px',
  containerStyle: {'zIndex':'9999'},
  // you can also just use 'fade'
  transition: transitions.FADE,
}

ArticleSlug.getLayout = function getLayout(page) {
  return (
      <AlertProvider template={AlertTemplate} {...alertOptions}>
          <AuthProvider>
              <Layout>
                  {page}
              </Layout>
          </AuthProvider>
      </AlertProvider>
  )
}
